export enum RouterSegments {
  SERVICES = 'services',
  CATALOGUE = 'catalogue',
  MY_SANDBOX = 'my-sandbox',
  MY_SERVICES = 'my-services',
  INSPIRATION_LOUNGE =  'inspiration-lounge',
  RESOURCES = 'resources',
  SUPER_FINANCE_APP =  'super-finance-app',
  TEEN_MATE_APP =  'teen-mate-app',
  FITNESS_SAVINGS_APP = 'fitness-savings-account',
  INSTANCES = 'instances',
  VIRTUAL_COO = 'virtual-coo',
  INDULGE = 'indulge',
  BLUEPRINTS = 'blueprints',
  CREATE = 'create',
  COMPOSE = 'compose',
  SERVICE_DEFINITION = 'definition',
  SETTINGS = 'settings',
  COMPOSABLE_BANKING = 'composable-banking',
  AUDIT_TRAIL = 'audit-trail',
  EXTEND = 'extend',
  DOWNLOAD_IAC = 'iac',
  DOWNLOADS = 'downloads',
  UNAUTHORIZED = 'unauthorized'
}
